import { makePrivateApiCall } from "utilities/dist/api";
import {
    CUSTOMER_BALANCE_DATA,
    CUSTOMER_BALANCE_ERROR,
    CUSTOMER_BALANCE_LOADING,
} from "../constants";

// Action Creators
export const setCustomerBalanceLoading = customerId => ({
    type: CUSTOMER_BALANCE_LOADING,
    payload: { customerId },
});

export const setCustomerBalanceData = (customerId, data) => ({
    type: CUSTOMER_BALANCE_DATA,
    payload: { customerId, data },
});

export const setCustomerBalanceError = (customerId, error) => ({
    type: CUSTOMER_BALANCE_ERROR,
    payload: { customerId, error },
});

// Thunk action to load the customer balance
export const loadCustomerBalance = customerId => {
    return dispatch => {
        dispatch(setCustomerBalanceLoading(customerId));
        return makePrivateApiCall({ url: `/customer/${customerId}/balance` })
            .then(res => dispatch(setCustomerBalanceData(customerId, res.data)))
            .catch(error => dispatch(setCustomerBalanceError(customerId, error)));
    };
};
